import { render, staticRenderFns } from "./PromoSection.vue?vue&type=template&id=6017e118&scoped=true&"
import script from "./PromoSection.vue?vue&type=script&lang=js&"
export * from "./PromoSection.vue?vue&type=script&lang=js&"
import style0 from "./PromoSection.vue?vue&type=style&index=0&id=6017e118&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6017e118",
  null
  
)

export default component.exports